module.exports = __webpack_public_path__ + "img/82200.85fbe160.jpg";